import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Plus, Pencil, Trash2, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';
import { blogAPI } from '../../services/api';

const BlogManager = ({ navigate }) => {
  const [blogs, setBlogs] = useState([]);

  const load = useCallback(async () => {
    try { const res = await blogAPI.getAll(); setBlogs(res.data || []); }
    catch { toast.error('Failed to load'); }
  }, []);

  useEffect(() => { load(); }, [load]);
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this blog post?')) return;
    try { await blogAPI.delete(id); toast.success('Deleted'); load(); }
    catch { toast.error('Failed to delete'); }
  };

  return (
    <div className="max-w-4xl">
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-gray-500">{blogs.length} blog posts</p>
        <Button onClick={() => navigate('/admin/blog/new')} data-testid="new-blog-btn">
          <Plus className="w-4 h-4 mr-2" /> New Post
        </Button>
      </div>
      <div className="space-y-3">
        {blogs.map(b => (
          <Card key={b._id}>
            <CardContent className="flex items-center justify-between py-4">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-semibold text-gray-900">{b.title}</h3>
                  {b.published ? (
                    <span className="flex items-center gap-1 text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full"><Eye className="w-3 h-3" /> Published</span>
                  ) : (
                    <span className="flex items-center gap-1 text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full"><EyeOff className="w-3 h-3" /> Draft</span>
                  )}
                </div>
                <p className="text-sm text-gray-500 mt-1">{b.excerpt || b.content?.slice(0, 100)}</p>
                <p className="text-xs text-gray-400 mt-1">by {b.author} - {new Date(b.published_at || b.created_at).toLocaleDateString()}</p>
              </div>
              <div className="flex gap-2 ml-4">
                <Button size="sm" variant="outline" onClick={() => navigate(`/admin/blog/edit/${b._id}`)}><Pencil className="w-4 h-4" /></Button>
                <Button size="sm" variant="destructive" onClick={() => handleDelete(b._id)}><Trash2 className="w-4 h-4" /></Button>
              </div>
            </CardContent>
          </Card>
        ))}
        {blogs.length === 0 && <p className="text-center py-8 text-gray-500">No blog posts yet.</p>}
      </div>
    </div>
  );
};

export default BlogManager;
